import React, { useEffect,useState } from "react";
import "./AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import Login from "../login/login";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const[isAuthenticated,setIsAuthenticated]=useState(false)

  useEffect(()=>{
    window.scrollTo(0,0)
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if(storedToken){
      setIsAuthenticated(true)
    }
  },[])
  
  if(isAuthenticated){
    return (
      <div className="dashboardContainer row">
        <div onClick={()=>navigate('/admin/addBlog')} className="card">
          <h2>Add Blog</h2>
        </div>
        <div onClick={()=>navigate('/admin/uploadBlogImage')} className="card">
          <h2>Upload Blog Image</h2>
        </div>
        <div className="card">
          <h2></h2>
        </div>
        <div className="card">
          <h2></h2>
        </div>
        <div className="card">
          <h2></h2>
        </div>
      </div>
    );
  }
else{
  return <Login/>
}

 
};

export default AdminDashboard;
